import combineComparators from 'commons/js/util/combineComparators'

import { STATUS_AVAILABLE } from 'commons/js/constants'

import { byDefault, byPriceAsc } from './comparators'

function isAvailable (bookingProduct) {
    return bookingProduct.availability.availabilityStatus === STATUS_AVAILABLE
}

function makeProductsComparator () {
    return combineComparators(
        byDefault,
        byPriceAsc
    )
}

export default function findBestAvailableProduct (bookingProducts) {
    const sortedProducts = bookingProducts
        // NOTE: We use slice here to clone original array, since sort mutates original one!
        .slice()
        .filter(isAvailable)
        .sort(makeProductsComparator())
    const [ firstProduct = null ] = sortedProducts

    return firstProduct
}
